module.exports = __webpack_public_path__ + "static/media/circle.5f9b042f.svg";